export interface ICommercialTab {
  id: string;
  title: string;
  description: string;
  imgUrl: string;
}

export interface ICommercial {
  title: string;
  description: string;
  tabs: ICommercialTab[];
}

export const commercial: ICommercial = {
  title: 'Коммерческая недвижимость',
  description:
    'В наших проектах есть не только квартиры, но и коммерческие помещения. Вы можете открыть рядом с домом кофейню или магазин, которые станут местом притяжения всего района. Мы уделяем особое внимание коммерческим помещениям, в которых мы соблюдаем ПИК-Стандарт.',
  tabs: [
    {
      id: 'showcase-glazing',
      title: 'Витринное остекление',
      imgUrl:
        'https://static.cdn-cian.ru/media/images/pik-landing_images/commercial/pik-landing_commercial_showcase.jpg',
      description: 'На первых этажах домов ПИК все окна — витринные. Ваш бизнес всегда хорошо заметен с улицы.',
    },
    {
      id: 'barrier-free',
      title: 'Безбарьерная среда',
      imgUrl:
        'https://static.cdn-cian.ru/media/images/pik-landing_images/commercial/pik-landing_commercial_barrier-free.jpg',
      description:
        'Войти в ваше помещение удобно всем, будь то родители с коляской или пожилые жители: никаких лишних порожков, лестниц и крутых пандусов. Разгружать товар и заносить оборудование тоже проще, когда уровень пола везде одинаковый.',
    },
    {
      id: 'passability',
      title: 'Высокая проходимость',
      imgUrl:
        'https://static.cdn-cian.ru/media/images/pik-landing_images/commercial/pik-landing_commercial_passability.jpg',
      description:
        'В большинстве проектов есть протяжённые пешеходные зоны, которые соединяют все кварталы района. Это излюбленные места встреч и прогулок со стабильно высоким трафиком.',
    },
    {
      id: 'open-layout',
      title: 'Открытая планировка',
      imgUrl: 'https://static.cdn-cian.ru/media/images/pik-landing_images/commercial/pik-landing_commercial_layout.jpg',
      description:
        'В помещениях почти нет перегородок, которые нельзя демонтировать. Планировки очень функциональны, так что вы сможете полностью обустроить помещение под нужды своего бизнеса.',
    },
    {
      id: 'universal-room',
      title: 'Универсальные помещения',
      imgUrl:
        'https://static.cdn-cian.ru/media/images/pik-landing_images/commercial/pik-landing_commercial_universal-room.jpg',
      description:
        'Мы не ограничиваем вас в выборе типа деятельности: помещения одинаково хорошо подойдут под салон красоты, химчистку или уютное кафе.',
    },
  ],
};
